import { Box, Typography } from '@mui/material';

import {
  OverlinedSpanStyled,
  SubtextStyled,
} from './OverlineWithSubtextStyled';
import { Spacer } from 'theSource/components';

export interface OverlineWithSubtextProps {
  title: string;
  subtext: string;
  subtextAsHeading?: boolean;
}

export const OverlineWithSubtext = ({
  title,
  subtext,
  subtextAsHeading = false,
}: OverlineWithSubtextProps) => (
  <Box data-testid="overline-with-subtext">
    <Typography component="div" variant="overline" textAlign="left">
      <OverlinedSpanStyled>{title}</OverlinedSpanStyled>
    </Typography>
    {!subtextAsHeading && <Spacer height={2} />}
    <SubtextStyled
      component="div"
      variant={subtextAsHeading ? 'body2Heading' : 'caption'}
    >
      {subtext}
    </SubtextStyled>
  </Box>
);
